import "./Home.module.css";
import BrandNavigationHeader from "@/reusable_sections/Header";
import DiscoverThePerfectName from "./sections/DiscoverThePerfectName";
import OurCuratedCollections from "./sections/OurCuratedCollections";
import TheArtOfNaming from "./sections/TheArtOfNaming";
import TrendingThisWeek from "./sections/TrendingThisWeek";
import ParentSuccessStories from "./sections/ParentSuccessStories";
import CommonQuestions from "./sections/CommonQuestions";
import JoinOurCommunity from "./sections/JoinOurCommunity";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <BrandNavigationHeader />
      <DiscoverThePerfectName />
      <OurCuratedCollections />
      <TheArtOfNaming />
      <TrendingThisWeek />
      <ParentSuccessStories />
      <CommonQuestions />
      <JoinOurCommunity />
      <CompanyDirectory />
    </div>;
}